class LWGallery extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.currentIndex = 0;
    }

    connectedCallback() {
    this.render();
    
    // Pak de slot en luister naar wanneer de inhoud (de plaatjes) binnenkomt
    const slot = this.shadowRoot.querySelector('slot');
    
    slot.addEventListener('slotchange', () => {
        this.images = Array.from(this.querySelectorAll('img'));
        
        this.images.forEach((img, index) => {
            img.style.cursor = 'zoom-in';
            // We halen oude onclicks weg en zetten de nieuwe erop
            img.onclick = (e) => {
                e.preventDefault();
                this.openImage(index);
            };
        });
    });

    // Toetsenbord pijltjes
    window.addEventListener('keydown', (e) => {
        const modal = document.querySelector('lw-modal');
        if (!modal || !modal.hasAttribute('active')) return;
        if (e.key === 'ArrowRight') this.navigate(1);
        if (e.key === 'ArrowLeft') this.navigate(-1);
    });
}
    openImage(index) {
        if (index === -1 || !this.images[index]) return;
        this.currentIndex = index;

        // Zoek de modal
        let modal = document.querySelector('lw-modal');
        
        // Als de modal niet bestaat, maak hem dan NU aan (On, Fast, and Working!)
        if (!modal) {
            modal = document.createElement('lw-modal');
            document.body.appendChild(modal);
        }

        const imgTag = `<img src="${this.images[index].src}" style="max-width:100%; max-height:90vh; display:block; margin:auto;">`;
        
        // Controleer of de modal de 'open' methode heeft
        if (typeof modal.open === 'function') {
            modal.open(imgTag);
        } else {
            // Fallback: als .open() er niet is, zet dan het attribuut
            modal.innerHTML = imgTag;
            modal.setAttribute('active', '');
        }
    }

    navigate(step) {
        this.currentIndex = (this.currentIndex + step + this.images.length) % this.images.length;
        this.openImage(this.currentIndex);
    }

    render() {
        const gap = this.getAttribute('gap') || '20px';
        const minWidth = this.getAttribute('min-width') || '200px';

        this.shadowRoot.innerHTML = /* html */ `
        <style>
            :host {
                display: block;
                position: relative;
                z-index: 100; /* Zorg dat de gallery boven de achtergrond ligt */
            }
            .grid {
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(${minWidth}, 1fr));
                gap: ${gap};
                margin-bottom: 15px;
                pointer-events: auto; /* Dwing klikbaarheid af */
            }
            ::slotted(img) {
                width: 100%; 
                height: 250px; /* Iets hoger voor magazine gevoel */
                object-fit: cover;
                border-radius: 4px;
                transition: transform 0.3s ease;
                cursor: zoom-in;
            }
            ::slotted(img:hover) { 
                transform: scale(1.03); 
                filter: brightness(0.9);
            }
        </style>
        <div class="grid">
            <slot></slot>
        </div>
        `;
    }
}
customElements.define('lw-gallery', LWGallery);